import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { useEffect } from 'react';
import Alert from '../Alert';
import { Box, Snackbar } from '@mui/material';

var SingleToast = function SingleToast(_ref) {
  var e2e = _ref.e2e,
      severity = _ref.severity,
      message = _ref.message,
      header = _ref.header,
      keyRender = _ref.keyRender,
      _ref$closeable = _ref.closeable,
      closeable = _ref$closeable === void 0 ? true : _ref$closeable,
      _ref$anchorOrigin = _ref.anchorOrigin,
      anchorOrigin = _ref$anchorOrigin === void 0 ? {
    vertical: 'top',
    horizontal: 'center'
  } : _ref$anchorOrigin,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 4000 : _ref$duration,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'outlined' : _ref$variant,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      action = _ref.action;
  var queueRef = React.useRef([]);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var _React$useState3 = React.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      messageInfo = _React$useState4[0],
      setMessageInfo = _React$useState4[1];

  var _React$useState5 = React.useState(duration),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      autoHideDuration = _React$useState6[0],
      setAutoHideDuration = _React$useState6[1];

  var processQueue = function processQueue() {
    if (queueRef.current.length > 0) {
      setMessageInfo(queueRef.current.shift());
      setOpen(true);
    }
  };

  useEffect(function () {
    setAutoHideDuration(duration);
  }, [duration]);
  useEffect(function () {
    if (!message) {
      return;
    }

    queueRef.current.push({
      message: message,
      header: header,
      severity: severity,
      key: keyRender || new Date().getTime()
    });

    if (open) {
      // immediately begin dismissing current message
      // to start showing new one !
      setOpen(false);
    } else {
      processQueue();
    }
  }, [message, header, severity, keyRender]);

  var handleClose = function handleClose(_, reason) {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  var handleExited = function handleExited() {
    processQueue();
  };

  var handleHover = function handleHover() {
    setAutoHideDuration(null);
  };

  var handleHoverEnd = function handleHoverEnd() {
    setAutoHideDuration(duration);
  };

  return /*#__PURE__*/React.createElement(Snackbar, _extends({}, e2e && {
    'data-e2e': e2e
  }, {
    key: (messageInfo === null || messageInfo === void 0 ? void 0 : messageInfo.key) || undefined,
    anchorOrigin: anchorOrigin,
    open: open,
    autoHideDuration: autoHideDuration,
    onClose: handleClose,
    onMouseEnter: handleHover,
    onMouseLeave: handleHoverEnd,
    transitionDuration: 100,
    TransitionProps: {
      onExited: handleExited
    }
  }), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Alert, _extends({}, e2e && {
    e2e: "".concat(e2e, "-alert")
  }, {
    severity: (messageInfo === null || messageInfo === void 0 ? void 0 : messageInfo.severity) || 'info',
    dsOnClose: handleClose,
    open: true,
    loading: loading,
    variant: variant,
    dismissible: closeable,
    body: messageInfo === null || messageInfo === void 0 ? void 0 : messageInfo.message,
    header: messageInfo === null || messageInfo === void 0 ? void 0 : messageInfo.header,
    action: action
  }))));
};

export default SingleToast;
//# sourceMappingURL=SingleToast.js.map